import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaddaModule } from 'angular2-ladda';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';

import { AppComponent } from './app.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { PipesModule } from './shared/pipes.module';
import { SharedModule} from './shared/shared.module';
import { TranslateModule } from './i18n/translate.module';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import {
  BsDatepickerModule,
  BsDropdownModule,
  TabsModule,
  TypeaheadModule,
  ModalModule,
  CarouselModule
} from 'ngx-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
//Directives
import { AlertComponent } from './directives/alert.component';

// Routing Module
import { AppRoutingModule } from './app.routing';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { OnlineAisleLayoutComponent } from './layouts/online-aisle-layout.component';
import { RFIDLayoutComponent } from './layouts/rfid-layout.component';

// 404
import { p404Component } from './pages/404.component';

// Guards
import {
  AdminGuard,
  AuthGuard,
  AuthOAGuard,
  AuthSheetsGuard,
  SupervisorGuard,
  AdminOrSupervisorGuard
} from './guards';

//Services
import {
  AuthenticationService,
  AlertService,
  BatchService,
  CanDeactivateGuard,
  CapacityConfigService,
  ConfigService,
  CredentialService,
  EODService,
  HorizonService,
  JobService,
  MQTTService,
  OrderService,
  PrinterService,
  ProductService,
  RoleService,
  ReportService,
  ScannerService,
  ScrapService,
  SettingService,
  ShipmentService,
  TemplateService,
  PublicService,
  RfidProductionService,
  PrestaSubassemblyService
} from './services';

//Ngrx Store
import { rootReducer } from '../ngrx/reducers';
import { ConfirmModalComponent } from './directives/confirm-modal/confirm-modal.component';
import { PublicLayoutComponent } from './layouts/public-layout.component';
import { HttpClientModule } from '@angular/common/http';
import { PromptModalComponent } from './directives/prompt-modal/prompt-modal.component';
import { RFIDUploadProofModalComponent } from './public/rfid-upload-proof/rfid-upload-proof-modal.component';
import { AuthInterceptorProvider } from './shared/interceptors/auth.interceptor';

@NgModule({
  imports: [
    BrowserModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LaddaModule,
    AppRoutingModule,
    MyDatePickerModule,
    NgxMyDatePickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    // CarouselModule.forRoot(),
    ChartsModule,
    PipesModule,
    HttpModule,
    HttpClientModule,
    ToasterModule,
    TypeaheadModule,
    SharedModule,
    StoreModule.provideStore(rootReducer),
    StoreDevtoolsModule.instrumentStore({
      maxAge: 10
    }),
    TranslateModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    OnlineAisleLayoutComponent,
    RFIDLayoutComponent,
    PublicLayoutComponent,
    AlertComponent,
    p404Component,
    ConfirmModalComponent,
    PromptModalComponent,
    RFIDUploadProofModalComponent
  ],
  entryComponents: [ConfirmModalComponent, PromptModalComponent, RFIDUploadProofModalComponent],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },
  AdminGuard,
  SupervisorGuard,
  AdminOrSupervisorGuard,
  AuthGuard,
  AuthOAGuard,
  AuthSheetsGuard,
  AuthenticationService,
  AlertService,
  BatchService,
  CapacityConfigService,
  CredentialService,
  ConfigService,
  EODService,
  HorizonService,
  TemplateService,
  JobService,
  PrinterService,
  ProductService,
  RoleService,
  MQTTService,
  CanDeactivateGuard,
  ToasterService,
  OrderService,
  ReportService,
  ScannerService,
  ScrapService,
  SettingService,
  ShipmentService,
  PublicService,
  AuthInterceptorProvider,
  RfidProductionService,
  PrestaSubassemblyService],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/app.module.ts